import config from '@/config';
import { ControllersData, LogicContext } from '@/logic/main/types';
import { extractRecentlyPlayedType } from '@/logic/main/utils';
import models from '@/model';
import { getLocale } from '@/utils';

const DEFAULT_GAME_NUMBER_LIMIT = 6; // default value for RP / Single Block

function getGamesNumberLimit(controllersData?: ControllersData): number {
  if (controllersData && controllersData.recentlyPlayed) {
    const { cmpType, gamesNumberLimitFromCMS } = extractRecentlyPlayedType(
      controllersData.recentlyPlayed
    );

    if (cmpType === 'Grid' && gamesNumberLimitFromCMS) {
      return gamesNumberLimitFromCMS;
    }
  }
  return DEFAULT_GAME_NUMBER_LIMIT;
}

export const fetchRecentlyPlayedGames = (context: LogicContext) => async () => {
  const authToken = context.user?.authToken?.access_token;
  const { controllersData } = context;

  const { status, data } = authToken
    ? await models.fetchRecentlyPlayed({
        authToken,
        locale: getLocale(config),
        market_country: config.viewer_country,
        market_region: config.viewer_region,
        limit: getGamesNumberLimit(controllersData),
      })
    : { status: 401, data: [] };

  return {
    status,
    recentlyPlayedGamesList: data,
  };
};
